import React, { useEffect } from 'react';

const AdWrapping = ({children, bannerType}) => {

    useEffect(() => {
        if (bannerType === 'page_bottom') {
            document.getElementsByTagName('BODY')[0].classList.add('hr-adhesion-loaded');
        }
    }, []);

    if (bannerType === 'page_bottom') {
        return (<div className={'ad--adhesion'}>
            {children}
        </div>)
    }

    if (bannerType === 'article_list') {
        return (<div className={'card card__banner flex align-middle'}>
            {children}
        </div>)
    }

    return (<>
        {children}
    </>)

};

export default AdWrapping;